import { Diamond } from "@src/types/DiamondDetail";
import { DefaultThemeValueType } from "../../../styled";
import { EdgeInsets } from "react-native-safe-area-context";
import {
  AdditionalAttributes,
  CartItem,
} from "@src/types/CartItemListResponse";
import { ProductCategory } from "@utils/constants";
import { BreadCrumbLabel } from "@components/molecules/Breadcrumbs/utils";

export type Props = {
  route?: PDPItemProps;
  onClose?: any;
  isOpen?: boolean;
  isModal?: boolean;
};

export type FooterSpaceProps = {
  insets: EdgeInsets;
};

export type PDPItemProps = {
  params: {
    productID: number;
    productType?: string;
    externalPriceMode?: number;
    fromRequestDetailsScreen?: boolean;
    fromDeepLink?: boolean;
    additionalAttributes?: AdditionalAttributes;
    componentData?: any;
    fromComponent?: boolean;
    breadCrumbLabel?: BreadCrumbLabel;
    type?: string;
  };
  isModal?: boolean;
};

export interface PDPGalleryProps {
  enableMatchPare?: boolean;
  isDiamond?: boolean;
  isLabgrown?: boolean;
  isGemstone?: boolean;
  isJewelry?: boolean;
  itemDetail?: Diamond;
  matchPairDetailData?: any;
  productColor?: DefaultThemeValueType;
  isModal?: boolean;
  enterSecondFlow?: boolean;
  productType?: any;
  priceMode?: any;
  testID?: string;
  dataTestId?: string;
}

export interface PDPGalleryProps {
  ReceivedDiamondData?: any;
  itemDetail?: Diamond;
  productType?: string;
  screenWidth?: number;
  testID?: string;
  dataTestId?: string;
}

export interface ProductDetailProps {
  itemDetail?: Diamond;
  title?: string;
  isJewelry?: boolean;
  isGemstone?: boolean;
  isLabgrown?: boolean;
  isDiamond?: boolean;
  isProductDetail?: boolean;
  productColor: DefaultThemeValueType;
  isPdpScreen?: boolean;
  productType?: ProductCategory;
  isFindAMatch?: boolean;
  orderCart?: CartItem;
  shipping_location?: any;
  showQuantityInHandAsText?: boolean;
  price_mode?: number;
}

export interface ProductHeaderDetailProps {
  itemDetail?: Diamond;
  isJewelry?: boolean;
  isGemstone?: boolean;
  productColor: DefaultThemeValueType;
  priceMode?: number;
  productAlphaColor: DefaultThemeValueType;
  productName?: string;
  hideReportIssue?: boolean;
  productType?: ProductCategory;
  showAvailabilityDot?: boolean;
  routeReferrer?: string;
}

export interface ProductCommentViewProps {
  ref: any;
  itemDetail?: Diamond;
  productColor?: DefaultThemeValueType;
  priceMode?: number;
  productType?: string;
  onLayout?: (event: any) => void;
}

export enum MenuConfigurationKey {
  HOME_SCREEN = "homeScreen",
  FAVORITES = "favorites",
  SEARCH = "search",
  REQUESTS = "requests",
  MORE_SETTINGS = "profile",
  PRODUCTS = "products",
}

export enum CustomisationKey {
  certificate = "certificate",
  report_issue = "report_issue",
  stock_no = "stock_no",
  product_badge = "product_badge",
  status = "status",
  last_refresh = "last_refresh",
  pricing_section = "pricing_section",
  price = "price",
  price_per_carat = "price_per_carat",
  discount_percent = "discount_percent",
  total_sales_price = "total_sales_price",
  retail_price = "retail_price",
  retail_price_name = "retail_price_name",
  retail_price_per_carat = "retail_price_per_carat",
  offer_price_per_carat = "offer_price_per_carat",
  rapnet_price = "rapnet_price",
  live_rapa_rate = "live_rapa_rate",
  shipping_information = "shipping_information",
  inclusion_open = "inclusion_open",
  retail_price_special = "retail_price_special",
  special_price = "special_price",
}

export const isInvalidFancyColorOvertone = (
  fancyColorOvertoneLong?: string
) => {
  const invalidFancyColorOvertoneArray = ["Champagne", "Cognac", "Chameleon"];
  if (fancyColorOvertoneLong) {
    return invalidFancyColorOvertoneArray.includes(fancyColorOvertoneLong);
  }
};

export const colorStringForShort = (isShort: boolean, itemDetail?: Diamond) => {
  let colorString = null;

  if (isShort) {
    if (isInvalidFancyColorOvertone(itemDetail?.fancy_color_overtone_long)) {
      colorString = itemDetail?.is_fancy
        ? `${
            itemDetail?.fancy_color_intensity_short || itemDetail?.color || ""
          } ${itemDetail?.fancy_color_short || ""}(${
            itemDetail?.fancy_color_overtone_long || ""
          })`
        : `${itemDetail?.fancy_color_long || itemDetail?.color || ""}`;
    } else {
      colorString = itemDetail?.is_fancy
        ? `${
            itemDetail?.fancy_color_intensity_short ||
            itemDetail?.fancy_color_intensity ||
            ""
          } ${itemDetail?.fancy_color_overtone_short || ""}${
            itemDetail?.fancy_color_short || ""
          }`
        : `${itemDetail?.fancy_color_long || itemDetail?.color || ""}`;
    }
  } else {
    if (isInvalidFancyColorOvertone(itemDetail?.fancy_color_overtone_long)) {
      colorString = itemDetail?.is_fancy
        ? [
            itemDetail?.fancy_color_intensity_long ||
              itemDetail?.fancy_color_intensity,
            itemDetail?.fancy_color_long,
            itemDetail?.fancy_color_overtone_long
              ? `(${itemDetail.fancy_color_overtone_long})`
              : null,
          ]
            .filter(Boolean)
            .join(" ")
        : itemDetail?.fancy_color_long || itemDetail?.color || "";
    } else {
      colorString = itemDetail?.is_fancy
        ? [
            itemDetail?.fancy_color_intensity_long ||
              itemDetail?.fancy_color_intensity,
            itemDetail?.fancy_color_overtone_long,
            itemDetail?.fancy_color_long,
          ]
            .filter(Boolean)
            .join(" ")
        : itemDetail?.fancy_color_long || itemDetail?.color || "";
    }
  }

  return colorString === "" ? "-" : colorString;
};
